import { motion } from "framer-motion";

export function LoadingScreen() {
  return (
    <div className="grid min-h-screen place-items-center bg-ink text-content-primary">
      <motion.div
        className="size-16 rounded-md border border-cyan-300/60 bg-cyan-300/10 shadow-neon"
        animate={{ rotate: 360, scale: [1, 1.08, 1] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
      />
    </div>
  );
}
